<script>
export default {
  name: 'ul.form.btn.submit.component',
  props: {
    module: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dsb() {
      return this.module.disabled
        || this.module.loading
        || this.disabled;
    },
  },
  methods: {
    click() {
      this.$emit('click');
      this.module
        .submit()
        .then((data) => {
          this.$emit('submit', data);
        }, () => {
          this.$emit('error');
        });
    },
  },
};
</script>
<template>
  <UlBtnPrimary
    class="ul-form-btn-submit"
    :disabled="dsb"
    @click="click"
  >
    <slot></slot>
  </UlBtnPrimary>
</template>
